/*
 * Kerzam CRO (Auftrag 08, 04.10.2026): Kaufleiste, Chat-Knopf, Lieferdatum, „Passt dazu“, Kassen-Leiste.
 * Auftrag 09 (05.10.2026): Chat-Logik ohne Layout-Abfragen beim Scrollen (A7), Fehlermeldung im Newsletter der Startseite.
 * Auftrag 10 (06.10.2026): „Jetzt kaufen“ (P1), Lieferdatum in Kurzform (P4), „Mehr lesen“ in den Text-Foto-Blöcken (P6).
 * Auftrag 11 (06.10.2026): Startseite am Handy: Chat-Knopf erst nach 200 px Scrollen (sichtbare H1 schiebt die Überschrift unter den Knopf).
 * Auftrag 12 (06.10.2026): Kopf-Icon und Sticky-„Warenkorb“ öffnen den Einschub (auch vor den verzögerten Theme-Skripten), Esc schließt,
 *   Zahl im Kopf des Einschubs, Bewertungs-Zusammenfassung „4,6 von 5 · 5 Bewertungen“ (nur Anzeige); 12b: Datum DE als TT.MM.JJJJ.
 * Nachtrag 12c (06.10.2026): Lieferdatum nach Wiener Uhrzeit – Versand bis 9 Uhr, Mo–Fr ohne österreichische Feiertage (eine Rechnung für alle Stellen).
 * Eingebunden in layout/theme.liquid, nur wenn Theme-Einstellungen › Kerzam CRO › Umbau aktiv.
 * Kein jQuery, keine Bibliothek. Ausblenden nur über Klassen am html-Element.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var mobil = window.matchMedia('(max-width: 767.98px)');
  var start = Date.now();

  function body() { return document.body; }
  function istSeite(name) { return body() && body().classList.contains(name + '-page'); }

  /* 1. Lieferdatum – eine Rechnung für alle Stellen: Kachel „Heute bestellt“ (snippets/kerzam-vorteile.liquid), Versand-Kasten im Einschub
        und auf /cart (snippets/kerzam-versand.liquid). Der alte Block „Lieferung und Rückgabe“ (snippets/product-information.liquid, nur mit
        „Umbau aktiv“ aus) rechnet seit Nachtrag 12c nicht mehr selbst.
        Nachtrag 12c (06.10.2026), Hamza: „Wir verschicken alles in der Früh bis 9 Uhr.“
        - Uhrzeit immer Wien (Intl mit timeZone Europe/Vienna), nicht die Zeitzone des Geräts.
        - Versandtag = heute, wenn heute Versandtag ist und es vor „Versand bis“ ist (Theme-Einstellungen › Lieferzeit, Standard 9 Uhr;
          9:00 zählt schon als danach), sonst der nächste Versandtag.
        - Versandtage Mo–Fr ohne österreichische Feiertage; Samstag nur mit „Auch samstags versenden“.
        - Lieferung = Versandtag + delivery_days_min … delivery_days_max Werktage (Mo–Fr ohne Feiertage).
        - Feiertage AT: 1.1., 6.1., Ostermontag, 1.5., Christi Himmelfahrt, Pfingstmontag, Fronleichnam, 15.8., 26.10., 1.11., 8.12.,
          25.12., 26.12.; Ostern wird je Jahr berechnet.
        Tage als UTC-Mitternacht gezählt (unabhängig von Sommerzeit und Geräte-Zeitzone), Anzeige mit timeZone UTC.
        Einstellungen aus window.kzLieferung (snippets/kerzam-kopf.liquid). Ohne JavaScript bleibt „in 1–3 Werktagen“ (Liquid).
        Der berechnete Versandtag steht zur Kontrolle im Attribut data-versandtag (JJJJ-MM-TT). */
  if (!window.mozaickDeliveryEstimate) {
    var TAG = 864e5;
    var wienJetzt = function (jetzt) {
      try {
        var p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
          .formatToParts(jetzt).forEach(function (x) { p[x.type] = x.value; });
        return { tag: Date.UTC(+p.year, +p.month - 1, +p.day), stunde: (+p.hour) % 24 };
      } catch (e) {
        return { tag: Date.UTC(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate()), stunde: jetzt.getHours() };
      }
    };
    var feiertagListe = {};
    var feiertage = function (j) {
      if (feiertagListe[j]) return feiertagListe[j];
      /* Ostersonntag (gregorianisch, Gauß) */
      var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        n = h + l - 7 * m + 114;
      var ostern = Date.UTC(j, Math.floor(n / 31) - 1, (n % 31) + 1);
      var s = {};
      [[1, 1], [1, 6], [5, 1], [8, 15], [10, 26], [11, 1], [12, 8], [12, 25], [12, 26]].forEach(function (x) { s[Date.UTC(j, x[0] - 1, x[1])] = true; });
      [1, 39, 50, 60].forEach(function (x) { s[ostern + x * TAG] = true; });
      feiertagListe[j] = s;
      return s;
    };
    var feiertag = function (t) { return !!feiertage(new Date(t).getUTCFullYear())[t]; };
    var werktag = function (t) { var w = new Date(t).getUTCDay(); return w >= 1 && w <= 5 && !feiertag(t); };
    var versandtag = function (t, samstag) { return werktag(t) || (samstag && new Date(t).getUTCDay() === 6 && !feiertag(t)); };
    var plusWerktage = function (t, n) { var x = 0; while (x < n) { t += TAG; if (werktag(t)) x++; } return t; };
    var einstellung = function () {
      var c = window.kzLieferung || {};
      var bis = parseInt(c.bis, 10);
      return { bis: isNaN(bis) ? 9 : bis, samstag: c.samstag === true };
    };
    var versandTag = function (jetzt) {
      var e = einstellung(), w = wienJetzt(jetzt), t = w.tag;
      if (!(versandtag(t, e.samstag) && w.stunde < e.bis)) {
        do { t += TAG; } while (!versandtag(t, e.samstag));
      }
      return t;
    };
    /* Auftrag 10 (P4): Kurzform „Mi., 7. – Fr., 9. Okt.“ (EN „Wed 7 – Fri 9 Oct“), Monat nur einmal, wenn beide Tage im selben Monat liegen */
    var teile = function (t, lang) {
      var p = {};
      new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
      return p;
    };
    var spanne = function (a, b, lang) {
      try {
        var de = /^de/i.test(lang);
        var pa = teile(a, lang), pb = teile(b, lang);
        /* Auftrag 21 (Nr. 80): Englisch amerikanisch „Tue, Oct 13 – Thu, Oct 15“ (Monat bei beiden Tagen), Deutsch unverändert */
        if (!de) return pa.weekday + ', ' + pa.month + ' ' + pa.day + ' – ' + pb.weekday + ', ' + pb.month + ' ' + pb.day;
        var tag = function (p) { return de ? p.weekday + ', ' + p.day + '.' : p.weekday + ' ' + p.day; };
        var da = new Date(a), db = new Date(b);
        var gleich = da.getUTCMonth() === db.getUTCMonth() && da.getUTCFullYear() === db.getUTCFullYear();
        return tag(pa) + (gleich ? '' : ' ' + pa.month) + ' – ' + tag(pb) + ' ' + pb.month;
      } catch (e) {
        return new Date(a).toLocaleDateString(undefined, { timeZone: 'UTC' }) + ' – ' + new Date(b).toLocaleDateString(undefined, { timeZone: 'UTC' });
      }
    };
    /* Auftrag 16, Zusatz B3: Kurzform nur für die Kachel (data-delivery-format="kurz"): ohne Wochentag „13.–15. Okt.“
       (EN „Oct 13–15“), bei Monatswechsel in Zahlen „30.10.–2.11.“ (EN „Oct 30–Nov 2“). Andere Stellen bleiben wie oben. */
    var kurz = function (a, b, lang) {
      try {
        var de = /^de/i.test(lang);
        var da = new Date(a), db = new Date(b);
        var mon = function (t) { return teile(t, lang).month; }; /* Monat wie in der Langform („Okt.“, „Sept.“; allein formatiert fehlt der Punkt) */
        var gleich = da.getUTCMonth() === db.getUTCMonth() && da.getUTCFullYear() === db.getUTCFullYear();
        if (de) {
          if (a === b) return da.getUTCDate() + '. ' + mon(a);
          if (gleich) return da.getUTCDate() + '.–' + db.getUTCDate() + '. ' + mon(b);
          return da.getUTCDate() + '.' + (da.getUTCMonth() + 1) + '.–' + db.getUTCDate() + '.' + (db.getUTCMonth() + 1) + '.';
        }
        if (a === b) return mon(a) + ' ' + da.getUTCDate();
        if (gleich) return mon(a) + ' ' + da.getUTCDate() + '–' + db.getUTCDate();
        return mon(a) + ' ' + da.getUTCDate() + '–' + mon(b) + ' ' + db.getUTCDate();
      } catch (e) {
        return spanne(a, b, lang);
      }
    };
    window.mozaickDeliveryEstimate = function () {
      var lang = document.documentElement.lang || 'de';
      var v = versandTag(new Date());
      document.querySelectorAll('.delivery-estimate[data-delivery-min]:not([data-delivery-done])').forEach(function (el) {
        var min = parseInt(el.getAttribute('data-delivery-min'), 10);
        var max = parseInt(el.getAttribute('data-delivery-max'), 10);
        if (isNaN(min) || isNaN(max)) return;
        if (max < min) max = min;
        el.textContent = (el.getAttribute('data-delivery-format') === 'kurz' ? kurz : spanne)(plusWerktage(v, min), plusWerktage(v, max), lang);
        el.setAttribute('data-versandtag', new Date(v).toISOString().slice(0, 10));
        el.setAttribute('data-delivery-done', 'true');
      });
    };
    document.addEventListener('shopify:section:load', window.mozaickDeliveryEstimate);
  }
  function lieferdatum() {
    try { window.mozaickDeliveryEstimate(); } catch (e) {}
  }

  /* 2. Cookie-Banner offen? Wie beim Chat-Knopf in consent-tracking: shouldShowBanner(),
        aber nur solange noch keine Entscheidung gespeichert ist (Werte 'yes'/'no'). */
  function bannerOffen() {
    var b = document.getElementById('shopify-pc__banner');
    if (b) {
      var cs = window.getComputedStyle(b);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0) return true;
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.shouldShowBanner !== 'function') return Date.now() - start < 3000;
    if (!cp.shouldShowBanner()) return false;
    var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
    if (c && (c.analytics || c.marketing || c.preferences)) return false;
    return true;
  }
  /* Auftrag 09 (A7): Der Takt schaltet nur die Klasse. pruefeChat läuft nur, wenn sich der Zustand ändert. */
  var bannerZustand = null;
  function pruefeBanner() {
    var offen = bannerOffen();
    if (offen === bannerZustand) return;
    bannerZustand = offen;
    root.classList.toggle('kz-banner-offen', offen);
    if (!offen) window.setTimeout(neuMessen, 60);
    pruefeChat();
  }

  /* 3. Warenkorb-Schublade offen? */
  function schubladeOffen() {
    var n = document.getElementById('cart-notification');
    return !!(n && n.classList.contains('active'));
  }

  /* 4. Chat-Knopf (Shopify Inbox): nie über Kaufbuttons oder Kaufleiste, aus in Schublade und auf /cart.
        Auftrag 09 (A7): Das Rechteck des Chat-Knopfs wird nur gemessen, wenn shopify-chat erscheint, wenn das
        Cookie-Banner zugeht und bei resize (gedrosselt 250 ms). Ob ein Button darunter liegt, meldet ein
        IntersectionObserver mit dem Chat-Bereich als Rand (rootMargin). Beim Scrollen keine Layout-Abfragen. */
  var chatBox = null;
  var ZIELE = '.product-summary .product-info .cart-btn, .product-summary .product-info .shopify-payment-button, .product-summary .product-info .quantity-btn, .product-summary .product-info .kz-passt-button';
  var LEISTE_BTN = '.sticky-addtocart.kz-leiste button[name="add"]';
  var ueber = [];
  var leisteUeber = false;
  var chatBeobachter = null;
  function chatRechteck() {
    var host = document.querySelector('shopify-chat');
    if (host && host.shadowRoot && !root.classList.contains('kz-chat-aus') && !root.classList.contains('mz-cookie-banner-offen')) {
      var btns = host.shadowRoot.querySelectorAll('button, [role="button"]');
      for (var i = 0; i < btns.length; i++) {
        var r = btns[i].getBoundingClientRect();
        if (r.width > 20 && r.height > 20) {
          chatBox = { l: r.left, t: r.top, r: r.right, b: r.bottom, vw: window.innerWidth, vh: window.innerHeight };
          break;
        }
      }
    }
    if (chatBox && chatBox.vw === window.innerWidth && chatBox.vh === window.innerHeight) return chatBox;
    var vw = window.innerWidth, vh = window.innerHeight;
    return { l: vw - 76, t: vh - 204, r: vw - 14, b: vh - 142 };
  }
  function baueChatBeobachter(a) {
    if (chatBeobachter) { chatBeobachter.disconnect(); chatBeobachter = null; }
    ueber = [];
    leisteUeber = false;
    if (!istSeite('product') || !('IntersectionObserver' in window)) return;
    var m = 8, vw = window.innerWidth, vh = window.innerHeight;
    var rand = [a.t - m, vw - a.r - m, vh - a.b - m, a.l - m].map(function (x) { return (-Math.max(0, Math.round(x))) + 'px'; }).join(' ');
    var leisteBtn = document.querySelector(LEISTE_BTN);
    chatBeobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        /* wie bisher: Elemente ohne Fläche zählen nicht */
        var drunter = e.isIntersecting && e.boundingClientRect.width > 0 && e.boundingClientRect.height > 0;
        if (e.target === leisteBtn) { leisteUeber = drunter; return; }
        var i = ueber.indexOf(e.target);
        if (drunter && i < 0) ueber.push(e.target);
        if (!drunter && i >= 0) ueber.splice(i, 1);
      });
      pruefeChat();
    }, { rootMargin: rand, threshold: 0 });
    document.querySelectorAll(ZIELE).forEach(function (el) { chatBeobachter.observe(el); });
    if (leisteBtn) chatBeobachter.observe(leisteBtn);
  }
  function neuMessen() {
    baueChatBeobachter(chatRechteck());
    pruefeChat();
  }
  function chatUeberButton() {
    if (ueber.length) return true;
    if (root.classList.contains('kz-leiste-an') && !root.classList.contains('kz-banner-offen')) {
      if (mobil.matches && leisteUeber) return true;
    }
    return false;
  }
  function pruefeChat() {
    var aus = false;
    if (istSeite('cart')) aus = true;
    else if (schubladeOffen()) aus = true;
    else if (istSeite('product')) aus = chatUeberButton();
    else if (istSeite('index')) aus = startOben && mobil.matches;
    root.classList.toggle('kz-chat-aus', aus);
  }
  /* Auftrag 11 (Folge von A1, Regel aus Auftrag 10 S1): Auf der Startseite am Handy verdeckt der Chat-Knopf sonst das Ende
     der Überschrift „Unsere beliebtesten Düfte“ im ersten Bildschirm. Er erscheint erst nach 200 px Scrollen.
     Ohne Scroll-Listener (A7): ein 1-px-Marker bei 199 px, beobachtet per IntersectionObserver. */
  var startOben = false;
  function initStartChat() {
    if (!istSeite('index') || !('IntersectionObserver' in window) || !document.body) return;
    var marker = document.createElement('div');
    marker.setAttribute('aria-hidden', 'true');
    marker.className = 'kz-start-marker';
    marker.style.cssText = 'position:absolute;left:0;top:199px;width:1px;height:1px;pointer-events:none;';
    document.body.appendChild(marker);
    startOben = (window.scrollY || window.pageYOffset || 0) < 200;
    new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { startOben = e.isIntersecting; });
      pruefeChat();
    }).observe(marker);
  }

  /* shopify-chat erscheint erst nach dem Laden: einmal beobachten, dann messen, sobald der Knopf gezeichnet ist */
  function warteAufChat() {
    var versuche = 0;
    function messenWennBereit() {
      var host = document.querySelector('shopify-chat');
      if (!host) return false;
      var ok = false;
      if (host.shadowRoot) {
        var btns = host.shadowRoot.querySelectorAll('button, [role="button"]');
        for (var i = 0; i < btns.length && !ok; i++) {
          if (btns[i].offsetWidth > 20) ok = true;
        }
      }
      if (ok || versuche > 8) { neuMessen(); return true; }
      versuche++;
      window.setTimeout(messenWennBereit, 500);
      return true;
    }
    if (messenWennBereit() || !('MutationObserver' in window) || !document.body) return;
    var mo = new MutationObserver(function () {
      if (document.querySelector('shopify-chat')) { mo.disconnect(); messenWennBereit(); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* 5. Kaufleiste: sichtbar, solange der Warenkorb-Button nicht im Bild ist (auch gleich nach dem Laden) */
  function initKaufleiste() {
    var leiste = document.querySelector('.sticky-addtocart.kz-leiste');
    var haupt = document.querySelector('.product-summary .product-info .cart-btn');
    if (!leiste || !haupt || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        root.classList.toggle('kz-leiste-an', !e.isIntersecting);
      });
      pruefeChat();
    }).observe(haupt);
  }

  /* 6. „Passt dazu“: erst laden, wenn Schublade offen bzw. auf /cart; Preise kommen aus Liquid */
  function ladeEmpfehlungen(bereich) {
    if (!bereich) return;
    bereich.querySelectorAll('[data-kz-passt]:not([data-kz-status])').forEach(function (box) {
      var url = box.getAttribute('data-url');
      if (!url) return;
      box.setAttribute('data-kz-status', 'laedt');
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var inhalt = doc.querySelector('.kz-passt-inhalt');
          box.innerHTML = inhalt ? inhalt.innerHTML : '';
          box.setAttribute('data-kz-status', box.querySelector('[data-kz-add]') ? 'fertig' : 'leer');
        })
        .catch(function () { box.setAttribute('data-kz-status', 'leer'); });
    });
  }

  function fehler(btn, text) {
    var box = btn.closest('[data-kz-passt]');
    var f = box && box.querySelector('.kz-passt-fehler');
    if (f) {
      f.textContent = text || (window.cartStrings && window.cartStrings.error) || '';
      f.hidden = !f.textContent;
    }
  }

  function warenkorbSeiteNeu(json) {
    var box = document.getElementById('main-cart-items');
    var sid = box && box.getAttribute('data-id');
    var html = sid && json.sections && json.sections[sid];
    if (!html) { window.location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['.checkout-content-left', '#main-cart-footer'].forEach(function (sel) {
      var neu = doc.querySelector(sel), alt = box.querySelector(sel);
      if (neu && alt) alt.innerHTML = neu.innerHTML;
    });
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { if (typeof window.cartCount === 'function') window.cartCount(c); })
      .catch(function () {});
  }

  function hinzufuegen(btn) {
    var id = parseInt(btn.getAttribute('data-kz-add'), 10);
    if (!id || btn.disabled) return;
    var seite = btn.closest('#main-cart-items');
    var cn = document.querySelector('cart-notification');
    var sections = [];
    if (seite) {
      sections = [document.getElementById('main-cart-items').getAttribute('data-id')];
    } else if (cn && typeof cn.getSectionsToRender === 'function') {
      sections = cn.getSectionsToRender().map(function (s) { return s.id; });
    } else {
      sections = ['cart-notification-content'];
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fehler(btn, '');
    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { fehler(btn, res.j.description || res.j.message); return; }
        if (seite) warenkorbSeiteNeu(res.j);
        else if (cn && typeof cn.renderContents === 'function') cn.renderContents(res.j);
        else window.location.reload();
      })
      .catch(function () { fehler(btn, ''); })
      .finally(function () {
        if (document.contains(btn)) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kz-add]');
    if (!btn) return;
    e.preventDefault();
    hinzufuegen(btn);
  });

  /* 7. Kassen-Leiste auf /cart (Handy): sichtbar, solange der Kassen-Button nicht im Bild ist */
  var kassenBeobachter = null;
  function initKassenleiste() {
    var btn = document.querySelector('#main-cart-items .cart__ctas button[name="checkout"]');
    if (kassenBeobachter) { kassenBeobachter.disconnect(); kassenBeobachter = null; }
    if (!btn || !('IntersectionObserver' in window)) { root.classList.remove('kz-kassenleiste-an'); return; }
    kassenBeobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { root.classList.toggle('kz-kassenleiste-an', !e.isIntersecting); });
    });
    kassenBeobachter.observe(btn);
  }

  /* 8. Schublade: Zustand, Neuaufbau (Section Rendering) und Empfehlungen */
  function schubladeGeaendert() {
    einschubAnzahl();
    root.classList.toggle('kz-schublade-offen', schubladeOffen());
    if (schubladeOffen()) ladeEmpfehlungen(document.getElementById('cart-notification-content'));
    lieferdatum();
    pruefeChat();
  }

  /* 9. Newsletter auf der Startseite (Auftrag 09): Fehlermeldung bei leerer oder ungültiger Adresse sichtbar im Formular,
        sonst schickt das Theme-Formular ab (Erfolgsmeldung wie bisher vom Theme). */
  function initNewsletter() {
    var texte = window.kzTexte || {};
    document.querySelectorAll('[id$="__kz_newsletter"] form.newsletter-form').forEach(function (form) {
      var feld = form.querySelector('input[type="email"]');
      if (!feld || form.getAttribute('data-kz-nl')) return;
      form.setAttribute('data-kz-nl', '1');
      form.setAttribute('novalidate', '');
      var meldung = document.createElement('p');
      meldung.className = 'kz-nl-fehler';
      meldung.id = (form.id || 'kz-newsletter') + '-fehler';
      meldung.setAttribute('role', 'alert');
      meldung.hidden = true;
      form.appendChild(meldung);
      form.addEventListener('submit', function (e) {
        var wert = (feld.value || '').trim();
        var gueltig = wert !== '' && feld.checkValidity() && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert);
        if (gueltig) return;
        e.preventDefault();
        meldung.textContent = wert === '' ? (texte.nlLeer || '') : (texte.nlUngueltig || '');
        meldung.hidden = false;
        feld.setAttribute('aria-invalid', 'true');
        feld.setAttribute('aria-describedby', meldung.id);
        feld.focus();
      });
      feld.addEventListener('input', function () {
        if (meldung.hidden) return;
        meldung.hidden = true;
        feld.removeAttribute('aria-invalid');
      });
    });
  }

  /* 10. „Jetzt kaufen“ (Auftrag 10, P1): Artikel mit Menge in den Warenkorb (/cart/add.js), dann sofort zur Kasse.
         Keine Schublade, kein Neuladen. Ohne JavaScript schickt der Knopf das Formular normal ab (Warenkorb). */
  function initJetztKaufen() {
    document.querySelectorAll('[data-kz-jetzt-kaufen]').forEach(function (btn) {
      if (btn.getAttribute('data-kz-bereit')) return;
      btn.setAttribute('data-kz-bereit', '1');
      var text = btn.textContent;
      var fehler = btn.parentNode.querySelector('.kz-jetzt-fehler');
      btn.addEventListener('click', function (e) {
        var form = btn.form || btn.closest('form');
        if (!form || !window.fetch) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btn.disabled) return;
        var idFeld = form.querySelector('[name="id"]');
        var menge = form.querySelector('[name="quantity"]') || (form.id && document.querySelector('[name="quantity"][form="' + form.id + '"]'));
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (f) { props[f.name.slice(11, -1)] = f.value; });
        if (!idFeld) return;
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-kz-warten') || text;
        if (fehler) fehler.hidden = true;
        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_ + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idFeld.value), quantity: Math.max(1, parseInt(menge && menge.value, 10) || 1), properties: props }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = root_ + 'checkout';
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = text;
          if (fehler) { fehler.textContent = btn.getAttribute('data-kz-fehler') || ''; fehler.hidden = false; }
        });
      }, true);
    });
  }

  /* 11. Text-Foto-Blöcke der Produktseite (Auftrag 10, P6): Text nach der Überschrift auf 4 Zeilen, „Mehr lesen“ / „Weniger“.
         Der ganze Text bleibt im Dokument; ohne JavaScript ist alles sichtbar. */
  function initMehrLesen() {
    if (!istSeite('product')) return;
    var texte = window.kzTexte || {};
    document.querySelectorAll('.image-with-text-3 .section-description').forEach(function (box, i) {
      if (box.getAttribute('data-kz-mehr')) return;
      box.setAttribute('data-kz-mehr', '1');
      var inhalt = document.createElement('div');
      inhalt.className = 'kz-mehr-inhalt';
      inhalt.id = 'kz-mehr-' + i;
      Array.prototype.slice.call(box.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && /^H[1-6]$/.test(n.tagName) && !inhalt.childNodes.length) return; // Überschrift am Anfang bleibt sichtbar
        inhalt.appendChild(n);
      });
      box.appendChild(inhalt);
      box.classList.add('kz-mehr-zu');
      if (inhalt.scrollHeight <= inhalt.clientHeight + 2) { box.classList.remove('kz-mehr-zu'); return; }
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'kz-mehr-knopf';
      knopf.setAttribute('aria-controls', inhalt.id);
      knopf.setAttribute('aria-expanded', 'false');
      knopf.textContent = texte.mehr || 'Mehr lesen';
      knopf.addEventListener('click', function () {
        var zu = box.classList.toggle('kz-mehr-zu');
        knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
        knopf.textContent = zu ? (texte.mehr || 'Mehr lesen') : (texte.weniger || 'Weniger');
      });
      box.appendChild(knopf);
    });
  }


  /* 12. Auftrag 12 (C1): Kopf-Icon und Sticky-Eintrag „Warenkorb“ (beide mit Attribut cart-icon-bubble) öffnen den Einschub, denselben
         wie nach „In den Warenkorb“. Das Theme macht das in main.min.js, das aber erst verzögert lädt (script-delay.js). Bis dahin
         wartet der Klick höchstens 3,5 s auf den Einschub und seinen Inhalt; kommt er nicht, geht es wie ohne JavaScript auf /cart. */
  function einschubOeffnen(link) {
    var cn = document.querySelector('cart-notification');
    if (!cn) return false;
    var bis = Date.now() + 3500;
    (function warte() {
      var c = document.querySelector('cart-notification');
      var inhalt = document.getElementById('cart-notification-content');
      if (c && typeof c.open === 'function' && inhalt && inhalt.children.length) { c.open(); return; }
      if (Date.now() > bis) { window.location.href = link.getAttribute('href') || '/cart'; return; }
      window.setTimeout(warte, 100);
    })();
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[cart-icon-bubble]') : null;
    if (!a) return;
    if (einschubOeffnen(a)) e.preventDefault();
  }, true);
  /* Esc schließt den Einschub; das ×-Feld ist auch per Tastatur bedienbar */
  function einschubSchliessen() {
    var cn = document.querySelector('cart-notification');
    if (cn && typeof cn.close === 'function') cn.close();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && schubladeOffen()) { einschubSchliessen(); return; }
    var z = e.target && e.target.closest ? e.target.closest('.kz-einschub-zu') : null;
    if (z && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); einschubSchliessen(); }
  });

  /* 13. Auftrag 12 (C2): Zahl im Kopf des Einschubs. Das Theme erneuert nach jeder Änderung nur Liste und Fuß; die Liste trägt
         die aktuelle Zahl (data-kz-anzahl). Nur schreiben, wenn sie sich ändert (der Beobachter würde sonst erneut auslösen). */
  function einschubAnzahl() {
    var liste = document.querySelector('#cart-notification-content [data-kz-anzahl]');
    var ziel = document.querySelector('#cart-notification-content [data-kz-einschub-anzahl]');
    if (!liste || !ziel) return;
    var text = '(' + liste.getAttribute('data-kz-anzahl') + ')';
    if (ziel.textContent !== text) ziel.textContent = text;
  }

  /* 14. Auftrag 12 (B3): Bewertungs-Zusammenfassung in einer Zeile, nur Anzeige: Schnitt mit einer Nachkommastelle (Deutsch mit
         Komma, „4.60 von 5“ → „4,6 von 5“), dahinter „· 5 Bewertungen“. Judge.me setzt Texte nach dem Laden teils neu: Die Funktion
         schreibt nur, wenn der Text vom Ziel abweicht (läuft bei jeder Änderung im Widget, ohne Schleife).
         Nachtrag 12b: Datum auf Deutsch als TT.MM.JJJJ, nur wenn der Text genau MM/DD/YYYY ist. Geprüft am Datum im Attribut
         data-content (UTC, ±1 Tag): Stellt Hamza Judge.me selbst auf TT/MM/JJJJ oder TT.MM.JJJJ um, bleibt der Text unberührt. */
  function datumDE(box) {
    box.querySelectorAll('.jdgm-rev__timestamp').forEach(function (el) {
      var t = (el.textContent || '').trim();
      var m = t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      var iso = (el.getAttribute('data-content') || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m || !iso) return;
      var alsMMTT = Date.UTC(+m[3], +m[1] - 1, +m[2]);
      var echt = Date.UTC(+iso[1], +iso[2] - 1, +iso[3]);
      if (+m[1] > 12 || Math.abs(alsMMTT - echt) > 864e5) return;
      var ziel = m[2] + '.' + m[1] + '.' + m[3];
      if (el.textContent !== ziel) el.textContent = ziel;
    });
  }
  function bewertungenFormat() {
    var box = document.querySelector('.kz-bewertungen[data-kz-bewertungen]');
    if (!box) return;
    var texte = window.kzTexte || {};
    var de = /^de/i.test(document.documentElement.lang || '');
    var avg = box.querySelector('.jdgm-rev-widg__summary-average');
    if (avg) {
      var t = avg.textContent || '';
      var m = t.match(/(\d+)[.,](\d+)/);
      if (m) {
        var zahl = (Math.round(parseFloat(m[1] + '.' + m[2]) * 10) / 10).toFixed(1);
        if (de) zahl = zahl.replace('.', ',');
        var ziel = t.replace(m[0], zahl);
        if (ziel !== t) avg.textContent = ziel;
      }
    }
    var sum = box.querySelector('.jdgm-rev-widg__summary-text');
    if (sum) {
      var w = box.querySelector('.jdgm-rev-widg');
      var n = (sum.textContent.match(/\d+/) || [])[0] || (w && w.getAttribute('data-number-of-reviews'));
      if (n) {
        var zielText = ((String(n) === '1' ? texte.bewEins : texte.bewViele) || '[count]').replace('[count]', n);
        if (sum.textContent.trim() !== zielText) {
          Array.prototype.slice.call(sum.childNodes).forEach(function (k) { if (k.nodeType === 3) sum.removeChild(k); });
          sum.insertBefore(document.createTextNode(zielText), sum.firstChild);
        }
      }
    }
    if (de) datumDE(box);
  }
  function initBewertungen() {
    var box = document.querySelector('.kz-bewertungen[data-kz-bewertungen]');
    if (!box) return;
    bewertungenFormat();
    if ('MutationObserver' in window) new MutationObserver(bewertungenFormat).observe(box, { childList: true, subtree: true });
  }

  function init() {
    lieferdatum();
    initJetztKaufen();
    initMehrLesen();
    initBewertungen();
    einschubAnzahl();
    pruefeBanner();
    initKaufleiste();
    neuMessen();
    warteAufChat();
    initNewsletter();

    var n = document.getElementById('cart-notification');
    if (n && 'MutationObserver' in window) {
      new MutationObserver(schubladeGeaendert).observe(n, { attributes: true, attributeFilter: ['class'] });
      var inhalt = document.getElementById('cart-notification-content');
      if (inhalt) new MutationObserver(schubladeGeaendert).observe(inhalt, { childList: true, subtree: true });
    }

    var cart = document.getElementById('main-cart-items');
    if (cart) {
      ladeEmpfehlungen(cart);
      initKassenleiste();
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          ladeEmpfehlungen(cart);
          lieferdatum();
          initKassenleiste();
        }).observe(cart, { childList: true, subtree: true });
      }
    }

    var takt = window.setInterval(function () {
      pruefeBanner();
      if (Date.now() - start > 12000) window.clearInterval(takt);
    }, 400);
    document.addEventListener('visitorConsentCollected', function () { window.setTimeout(pruefeBanner, 50); });
    document.addEventListener('shopify:section:load', function () { window.setTimeout(neuMessen, 60); });

    initStartChat();

    /* Auftrag 09 (A7): kein Scroll-Listener mehr. Bei resize gedrosselt (250 ms) neu messen. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) return;
      resizeTimer = window.setTimeout(function () { resizeTimer = null; neuMessen(); }, 250);
    }, { passive: true });
    pruefeChat();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
